import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = ()  =>{
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center">
      <div className="max-w-md px-4 sm:px-6 lg:px-8">
        <h1 className="text-9xl font-bold text-gray-800">404</h1>
        <h2 className="text-2xl font-medium text-gray-600 mt-4">Page Not Found</h2>
        <p className="text-gray-500 mt-2">
          Oops! The page you're looking for doesn't exist.
        </p>
        <Link to="/" className="inline-block px-6 py-3 mt-6 text-white bg-teal-600 rounded-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-400">
          Go back to Home
        </Link>
      </div>
    </div>
  );
}
